module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p5-b29be1809cee0e0a6a97b5c8e44577a0.png";